import React, { useCallback } from 'react';
import { cleanText } from '../../../helpers/common-helpers';
import { useTrackingManager } from '../../../tracking/use-tracking-manager';

// helper para poder usar novedades-carousel como un componente único (usado en portal y mantenimiento) -
// los nombres de las funciones de tracking cambian en cada contexto
// en mantenimiento - cambiamos el contenido de las funciones manteniendo el nombre de las funciones de salida

export const useNovedadesTracker = ({ itemId }: { itemId: string }) => {
	const trackingManager = useTrackingManager();
	const cleanItemId = cleanText(itemId);

	const trackOpenLayerClick = (ctaLabel: string) => {
		const cleanCtaLabel = cleanText(ctaLabel);
		trackingManager.trackClubVWButtonClick(`${cleanCtaLabel} - Novedades - Open Layer - ${cleanItemId}`, {
			contentId: `${cleanCtaLabel} - Novedades - Open Layer - ${cleanItemId}`,
		});
	};

	const trackLayerLoad = React.useCallback(() => {
		trackingManager.trackClubVWLayerLoad({ contentId: `Novedades - ${cleanItemId}` });
	}, [trackingManager, cleanItemId]);

	const trackLayerCloseClick = useCallback(() => {
		trackingManager.trackClubVWLayerCloseClick(`Novedades - ${cleanItemId}`, {
			contentId: `Novedades - ${cleanItemId}`,
		});
	}, [trackingManager, cleanItemId]);

	const trackCardClick = useCallback(
		(ctaLabel: string) => {
			const cleanCtaLabel = cleanText(ctaLabel);
			trackingManager.trackClubVWButtonClick(`${cleanCtaLabel} - Novedades - ${cleanItemId}`, {
				contentId: `${cleanCtaLabel} - Novedades - ${cleanItemId}`,
			});
		},
		[trackingManager, cleanItemId],
	);

	return {
		trackOpenLayerClick,
		trackLayerLoad,
		trackLayerCloseClick,
		trackCardClick,
	};
};
